import { Nuisible, NuisibleCreateInput, NuisibleListResponse, NuisibleResponse, NuisibleSelectInput, NuisibleUpdateInput } from "@repo/types";
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';

export interface NuisibleFilters extends Partial<NuisibleSelectInput> {
  includeDeleted?: boolean;
  sortBy?: 'recent' | 'oldest' | 'alphanum';
}

export class NuisibleService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.NUISIBLES.BASE, axios);
  }

  async getNuisibles(filters: NuisibleFilters): Promise<NuisibleListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated<Nuisible>({ page, limit, ...rest });
  }

  async getNuisibleById(id: number): Promise<NuisibleResponse> {
    return this.get<NuisibleResponse>(`/${id}`);
  }

  async createNuisible(data: NuisibleCreateInput): Promise<NuisibleResponse> {
    return this.post<NuisibleResponse, NuisibleCreateInput>('', data);
  }

  async updateNuisible(id: number, data: NuisibleUpdateInput): Promise<NuisibleResponse> {
    return this.put<NuisibleResponse, NuisibleUpdateInput>(`/${id}`, data);
  }

  async deleteNuisible(id: number): Promise<NuisibleResponse> {
    return this.delete<NuisibleResponse>(`/${id}`);
  }

  async selectNuisibles(params: NuisibleSelectInput): Promise<{ data: Nuisible[] }> {
    return this.get<{ data: Nuisible[] }>('/select');
  }
}